import { render, staticRenderFns } from "./register-dialog.vue?vue&type=template&id=40a22e6d"
import script from "./register-dialog.vue?vue&type=script&lang=js"
export * from "./register-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports